import type { EditableContentUnit } from '@/features/content/editor/editorTypes';

import type {
  ContentSection,
  ContentSectionGroupingResult,
} from './sectionTypes';

export const UNTITLED_SECTION_TITLE = 'Untitled section';

export function isTopLevelHeading(unit: EditableContentUnit): boolean {
  return (
    Boolean(unit.heading) &&
    !unit.disableAutoNumbering &&
    !unit.collapseByDefault
  );
}

function getSectionTitle(unit: EditableContentUnit) {
  return unit.heading?.trim() || UNTITLED_SECTION_TITLE;
}

export function getSectionUnitCount(section: ContentSection) {
  return 1 + section.bodyUnits.length;
}

export function getSectionUnits(section: ContentSection): EditableContentUnit[] {
  return [section.headerUnit, ...section.bodyUnits];
}

export function groupUnitsIntoSections(
  units: EditableContentUnit[],
): ContentSectionGroupingResult {
  const preIntroUnits: EditableContentUnit[] = [];
  const preIntroUnitIndices: number[] = [];
  const sections: ContentSection[] = [];
  let currentSection: ContentSection | null = null;

  units.forEach((unit, index) => {
    if (isTopLevelHeading(unit)) {
      currentSection = {
        bodyUnitIndices: [],
        bodyUnits: [],
        headerUnit: unit,
        headerUnitIndex: index,
        id: unit.id,
        title: getSectionTitle(unit),
      };
      sections.push(currentSection);
      return;
    }

    if (!currentSection) {
      preIntroUnits.push(unit);
      preIntroUnitIndices.push(index);
      return;
    }

    currentSection.bodyUnits.push(unit);
    currentSection.bodyUnitIndices.push(index);
  });

  return {
    preIntroUnitIndices,
    preIntroUnits,
    sections,
  };
}
